<app-offcanvas-base [returnUrl]="returnUrl">
  <ng-container title> Employee details </ng-container>
  <ng-container body>
    @if (employee) {
      @if (employee.contact_change_pending) {
        <div class="alert alert-warning">
          <i class="iconoir-warning-circle"></i> Employee contact details verification is pending
        </div>
      }
      <div class="mb-3">
        <app-avatar
          [firstName]="employee.first_name"
          [lastName]="employee.last_name"
          [size]="'xl'"></app-avatar>
      </div>
      <div class="info-item">
        <div class="info-label">First name:</div>
        <div
          class="info-text"
          id="firstName">
          {{ employee.first_name }}
        </div>
      </div>
      <div class="info-item">
        <div class="info-label">Last name:</div>
        <div
          class="info-text"
          id="lastName">
          {{ employee.last_name }}
        </div>
      </div>
      <div class="info-item">
        <div
          class="info-label"
          id="idnumType">
          {{
            !employee.idnum_type || employee.idnum_type === IdNumType.RSAID
              ? 'South African identity number'
              : 'Passport number'
          }}
        </div>
        <div class="info-text">{{ maskService.idNumberMask(employee.idnum) | emptyIndicator: 'N/A' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">Phone number:</div>
        <div class="info-text">
          <div class="row align-items-center">
            <div class="col-auto">{{ maskService.formatInternationalPhone(employee.phone) }}</div>
            @if (!employee.phone_verified) {
              <div class="col-auto ps-0">
                <span
                  class="ms-1 warning-icon"
                  [ngbTooltip]="'We are waiting on the updated phone number to be verified.'">
                  <i class="iconoir-warning-circle"></i>
                </span>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="info-item">
        <div class="info-label">Email address:</div>
        <div class="info-text">
          <div class="row align-items-center">
            <div
              class="col-auto"
              id="email">
              {{ employee.email }}
            </div>
            @if (!employee.email_verified) {
              <div class="col-auto ps-0">
                <span
                  class="ms-1 warning-icon"
                  [ngbTooltip]="'We are waiting on the updated email to be verified.'">
                  <i class="iconoir-warning-circle"></i>
                </span>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="info-item">
        <div class="info-label">User Type:</div>
        <div class="info-text">{{ employee.role === EmployeeRoleType.ADMIN ? 'Admin' : 'Cardholder' }}</div>
      </div>
      <div class="info-item">
        <div class="info-label">Issue card:</div>
        <div class="info-text">
          <div class="row align-items-center">
            <div class="col-auto pe-0 issue-card-icon">
              <i
                [ngClass]="employee.is_card_holder ? 'text-secondary' : 'text-muted'"
                class="iconoir-credit-card"></i>
            </div>
            <div class="col">
              Employee card
              @if (!employee.is_card_holder) {
                <span>not</span>
              }
              issued
            </div>
          </div>
        </div>
      </div>
      @if (!!employee.approvers?.length) {
        <div class="info-item">
          <div class="info-label">Approvers</div>
          <div class="info-text mt-1">
            @for (approver of employee.approvers; track approver.id) {
              <div class="badge bg-secondary me-2">{{ approver.name }}</div>
            }
          </div>
        </div>
      }
      <div class="row gy-3 offcanvas-buttons">
        @if (employee.email !== userProfileEmail) {
          <div class="col-12 col-sm-auto">
            <button
              class="btn btn-outline-dark"
              (click)="onRemoveEmployee(employee)">
              Remove
            </button>
          </div>
        }
        <div class="col-12 col-sm-auto ms-sm-auto">
          <button
            (click)="onEditEmployee()"
            class="btn btn-primary">
            Edit
          </button>
        </div>
      </div>
    } @else {
      <app-loader></app-loader>
    }
  </ng-container>
</app-offcanvas-base>
